import _ from '@luna/lodash';
import { exportFeatures, transactions } from '@retail/transactions-config';
import { plugins } from '@retail/plugins-config';
import {
    AccountsCurrentFeatureConfig,
    AccountsFeatureConfig,
    ProductsFeatureConfig,
    SavingsFeatureConfig,
    StatementFeatureConfig,
} from '@retail/products-config';
import { cards } from '@retail/cards-config';
import { contactDataManagement } from '@shared/contact-data-management-config';

import { arrayOverwrite, baseFeatureConfig, extendFeatureConfigFromUrl } from './base';
import type { PartialRetailFeatureConfig } from './featureConfig';

export const countryFeatureConfig: PartialRetailFeatureConfig = {
    contactDataManagement: contactDataManagement.RS,
    currentAccount: AccountsCurrentFeatureConfig.RS,
    accounts: AccountsFeatureConfig.RS,
    savings: SavingsFeatureConfig.RS,
    cards: cards.RS,
    export: exportFeatures.RS,
    base: {
        country: 'RS',
        ibanCountryCode: 'RS',
        allowedLanguages: ['sr', 'en'],
        availableLanguages: ['sr-Latn', 'en', 'en-SC'],
        defaultLanguage: 'sr-Latn',
        defaultCurrency: 'RSD',
        defaultCurrencySign: 'RSD',
        sendLanguageHeader: true,
        preferWebApiLanguage: true,
        defaultTimezone: 'Europe/Belgrade',
        passCredentialsInRequest: true,
        loanProductAmount: 'balance',
        languageOverrides: {
            en: 'en-SC',
        },
        languageScriptOverrides: {
            sr: 'sr-Latn',
        },
        mainProductAmount: 'disposable',
        latestVersionHeader: null,
        useVersionHeaders: false,
    },
    products: ProductsFeatureConfig.RS,
    plugins: plugins.RS,
    footer: {
        links: {
            referenceInterestRates: {
                en: 'https://www.erstebank.rs/sr/Stanovnistvo/vrednosti-referentnih-kamatnih-stopa',
                sr: 'https://www.erstebank.rs/sr/Stanovnistvo/vrednosti-referentnih-kamatnih-stopa',
                'sr-Latn':
                    'https://www.erstebank.rs/sr/Stanovnistvo/vrednosti-referentnih-kamatnih-stopa',
            },
            processingOfPersonalData: {
                en: 'https://www.erstebank.rs/content/dam/rs/ebs/www_erstebank_rs/onama/Notice-on-the-Processing-of-Personal-Data-of-Users-of-the-George-Application.pdf',
                sr: 'https://www.erstebank.rs/content/dam/rs/ebs/www_erstebank_rs/onama/Obavestenje-o-obradi-podataka-o-licnosti-korisnika-George-aplikacije.pdf',
                'sr-Latn':
                    'https://www.erstebank.rs/content/dam/rs/ebs/www_erstebank_rs/onama/Obavestenje-o-obradi-podataka-o-licnosti-korisnika-George-aplikacije.pdf',
            },
        },
    },
    devTools: {
        availableEnvironments: {
            Local: 'http://localhost:8080',
            Dev: 'https://rs.dev.beeone.at',
            'Fat Blue': 'https://george.blue.fat.erstebank.rs',
            'Fat Green': 'https://george.green.fat.erstebank.rs',
        },
        availableApiTargets: {
            'FAT BLUE': ['https://george.blue.fat.erstebank.rs'],
            'FAT GREEN': ['https://george.green.fat.erstebank.rs'],
        },
    },
    tracking: {
        appId: 'INT96',
        appName: 'GeorgeWeb_Retail_RS',
        instituteId: 784,
    },
    allowedRedirectDomains: ['erstebank.rs'],
    statements: StatementFeatureConfig.RS,
    transactions: transactions.RS,
};

const featuresWithBase = _.merge({}, baseFeatureConfig, countryFeatureConfig, arrayOverwrite);
export const featureConfig = extendFeatureConfigFromUrl(featuresWithBase);
